import authService from "@/core/services/auth.service";
import {store} from './../../plugins/vuex/index'
import {ARTISIO_IDLE_TRACKER_KEY} from "@/modules/constants";
import i18n from "@/shared/i18n";

const defaultEventOption = {
  capture: false,
  passive: false,
};

const events = [
  'change',
  'keydown',
  'mousedown',
  'mousemove',
  'mouseup',
  'orientationchange',
  'resize',
  'scroll',
  'touchend',
  'touchmove',
  'touchstart',
  'visibilitychange',
]

class ArtisioIdleTracker {
  listeners = [];
  supportsPassiveEvent = false;
  lastActiveDate = null;
  interval = null;

  checkSupportPassiveEvents() {
    let vm = this;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function () {
          vm.supportsPassiveEvent = true;
          return true
        }
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
    } catch (e) {
      console.log("Passive event not supported");
    }
  }

  start(throttleTime = 1000 * 60 * 30) {
    this.throttleTime = throttleTime;
    this.checkSupportPassiveEvents();
    this.registerEventListeners();
    this.setLastActiveDate(Date.now());
    this.startInterval()
  }

  async stop() {
    this.removeEventListeners();
    this.stopInterval();
    await store.dispatch('global/updateLoginAlertMessage', i18n.t("Your session has expired due to inactivity. Please log in to continue."))
    await authService.logout();
  }

  registerEventListeners() {
    this.handleEvent = this.handleEvent.bind(this);
    this.listeners = events.map((eventName) => {
      document.addEventListener(
        eventName, this.handleEvent, this.supportsPassiveEvent ? defaultEventOption : false,
      );
      return eventName;
    });
  }

  removeEventListeners() {
    if (this.listeners.length) {
      this.listeners.forEach((eventName) => document.removeEventListener(
        eventName, this.handleEvent, this.supportsPassiveEvent ? defaultEventOption : false,
      ));
    }
  }

  startInterval() {
    this.interval = setInterval(async () => {
      if (this.isIdle()) {
        await this.stop();
      }
    }, 10000)
  }

  stopInterval() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  setLastActiveDate(date) {
    this.lastActiveDate = date;
    localStorage.setItem(ARTISIO_IDLE_TRACKER_KEY, date)
  }

  getLastActiveDate() {
    return parseInt(localStorage.getItem(ARTISIO_IDLE_TRACKER_KEY))
  }

  handleEvent() {
    let currentTime = Date.now();
    if ((currentTime - this.lastActiveDate) <= 5000) {
      return
    }
    this.setLastActiveDate(currentTime)
  }

  isIdle() {
    return Date.now() - this.getLastActiveDate() >= this.throttleTime
  }
}

export default ArtisioIdleTracker;
